import { FaHtml5, FaCss3Alt, FaBootstrap, FaJs, FaReact, FaNodeJs, FaPhp, FaLaravel } from "react-icons/fa";
import { SiCplusplus, SiPython, SiCsharp, SiFlutter, SiSqlite, SiMongodb, 
  SiExpress, SiRedux, SiNextdotjs, SiTailwindcss, SiMysql } from "react-icons/si";

const Skills = () => {
  return (
    <div className="bg-black text-white py-20" id="skill">
      <div className="mt-10 container mx-auto px-8 md:px-16 lg:px-24">
        <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-purple-800 to-purple-400 bg-clip-text text-transparent">
          SKILLS
        </h2>

        <div className="flex flex-col md:flex-row justify-center gap-12">
          <div className="bg-gray-800 border-2 border-purple-800 px-6 rounded-lg hover:shadow-lg transform transition-transform duration-300 hover:scale-105 w-full md:w-1/3">
            <h3 className="text-2xl font-semibold mb-6 text-white pt-2 text-center">Frontend</h3>
            <ul className="space-y-3">
              {[
                { Icon: FaHtml5, name: "HTML" },
                { Icon: FaCss3Alt, name: "CSS" },
                { Icon: FaBootstrap, name: "Bootstrap" },
                { Icon: SiTailwindcss, name: "Tailwind CSS" },
                { Icon: FaReact, name: "React.js" },
                { Icon: SiRedux, name: "Redux.js" },
                { Icon: SiNextdotjs, name: "Next.js" }
              ].map((skill, index) => (
                <li key={index} className="flex items-center text-sm space-x-4 p-2 rounded-lg hover:bg-purple-900/20 transition-colors duration-300">
                  <skill.Icon size={25} className="text-purple-400" />
                  <span>{skill.name}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-gray-800 border-2 border-purple-800 px-6 rounded-lg hover:shadow-lg transform transition-transform duration-300 hover:scale-105 w-full md:w-1/3">
            <h3 className="text-2xl font-semibold mb-6 text-white pt-2 text-center">Programming Languages</h3>
            <ul className="space-y-3 pb-4">
              {[
                { Icon: FaJs, name: "JavaScript" },
                { Icon: SiCplusplus, name: "C++" },
                { Icon: SiPython, name: "Python" },
                { Icon: SiCsharp, name: "C#" },
                { Icon: SiFlutter, name: "Flutter" },
                { Icon: SiSqlite, name: "SQL" }
              ].map((skill, index) => (
                <li key={index} className="flex items-center text-sm space-x-4 p-2 rounded-lg hover:bg-purple-900/20 transition-colors duration-300">
                  <skill.Icon size={25} className="text-purple-400" />
                  <span>{skill.name}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-gray-800 border-2 border-purple-800 px-6 rounded-lg hover:shadow-lg transform transition-transform duration-300 hover:scale-105 w-full md:w-1/3">
            <h3 className="text-2xl font-semibold mb-6 text-white pt-2 text-center">Backend & Database</h3>
            <ul className="space-y-3 pb-4">
              {[
                { Icon: FaNodeJs, name: "Node.js" },
                { Icon: SiExpress, name: "Express.js" },
                { Icon: SiMongodb, name: "MongoDB" },
                { Icon: FaPhp, name: "PHP" },
                { Icon: FaLaravel, name: "Laravel" },
                { Icon: SiMysql, name: "MySQL" }
              ].map((skill, index) => (
                <li key={index} className="flex items-center text-sm space-x-4 p-2 rounded-lg hover:bg-purple-900/20 transition-colors duration-300">
                  <skill.Icon size={25} className="text-purple-400" />
                  <span>{skill.name}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
